<template>
  <div class="ssh-list-container init ">
    <div class="cps-page-top">
      <div class="jc-page-header">
        <el-page-header :title="$t('ssh.text.ssh')" />
        <div class="jc-box-action">
          <a :href="Config.SSH_HELP_URL" target="_blank">
            {{$t('ssh.help.doc')}}
          </a>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="jc-container-table">
          <!--表格上方的操作栏-->
          <div class="jc-container-table-actionBar flex-display">
            <el-form class="jc-table-actionBar-item" :inline="true">
              <!--刷新-->
              <el-form-item>
                <el-button icon="jc-icon-refresh-line" class="jc-button-icon"
                           @click="updateList('refresh')"></el-button>
              </el-form-item>
              <!--切换地域-->
              <el-form-item>
                <el-radio-group v-model="selectedRegion" @change="updateList('refresh')">
                  <el-radio-button :label="item.region" v-for="item in regions">
                    {{item.regionName}}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!--跳转到创建页-->
              <el-form-item>
                <el-button type="primary" @click="openCreateSSHDialog">
                  {{$t('listPage.text.create')}}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <!--SSH表格-->
          <el-table :data="tableData" v-loading="loading"
                    :empty-text="$t('speechCraft.listEmptyText')">
            <!--密钥对名称-->
            <el-table-column :label="$t('ssh.text.name')" min-width="300" prop="name">
              <template slot-scope="scope">
                <a href="javascript:void(0)" @click="jumpToDetail(scope.row)">
                  {{scope.row.name | maybeEmpty}}
                </a>
              </template>

            </el-table-column>
            <!--创建时间-->
            <el-table-column :label="$t('ssh.text.createTime')" min-width="300" prop="createTime">
            </el-table-column>
            <!--操作-->
            <el-table-column :label="$t('listPage.tableLabel.operation')" min-width="300">
              <template slot-scope="scope">
                <!--根据接口返回字段判断是否可以删除-->
                <el-tooltip v-if="scope.row.isCheckDelete === 'no'"
                            :content="$t('ssh.help.deleteNotAllowed')">
                  <span
                    :class="[{'a-disabled':scope.row.isCheckDelete === 'no'}]">
                    {{$t('subnet.text.delete')}}</span>
                </el-tooltip>
                <a v-else href="javascript:void(0)" @click="selectOpts(SSHOperationConstant.DELETE, scope.row)">
                  {{$t('subnet.text.delete')}}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <create-ssh :dialog-visible="sshDialogVisible" :current-region="selectedRegion"
                  @ifDialogVisible='syncCreateDialogVisibleData'
                  @refreshList='updateListWithoutLoading("refresh")' v-if="sshDialogVisible">

      </create-ssh>
    </div>
    <div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
    NetworkTypeConstant
} from '@/common/Constants';
import Custom from '@/components/common/custom/Custom';
import CreateSsh  from '@/components/ssh/create/Create'
import {SSHOperationConstant} from '@/common/Constants'
const initPage = 1;

export default {
  components: {
    Custom,
    CreateSsh
  },
  name: 'SSHList',
  data(){
    return {
      // 创建弹框是否可见
      sshDialogVisible: false,
      currentPage: initPage,
      initPage,
      regions:[],
      regionMap: {},
      tableData: [],
      selectedRegion: '',
      loading: false,
      // 当前搜索条件
      currentSearch: '',
      // 当前搜索input框值
      currentSearchValue: '',
      // 当前搜索条件对应placeholder
      currentPlaceholder: this.$t('eip.placeholder.search.ipAddress'),
      pageSize: 20,
      pageSizes: [20, 50, 100], // 可选每页展示多少条
      total: 0,
      // 自定义列表是否显示
      customVisible: false,
      // 自定义列表表头
      optionArr: [
        {
          // 密钥对名称
          label: this.$t('ssh.text.name'),
          value: 'name'
        },
        {
          // 创建时间
          label: this.$t('ssh.text.createTime'),
          value: 'createTime'
        },
        {
          // 操作
          label: this.$t('listPage.tableLabel.operation'),
          value: 'operation'
        }
      ],
      // 自定义列表类型
      type: 'sshList',
    }
  },
  mounted(){
    this.getRegion();
  },
  created(){},
  watch: {},
  computed: {
    SSHOperationConstant: () => SSHOperationConstant
  },
  methods: {
    // 打开创建密钥弹框
    openCreateSSHDialog() {
      this.sshDialogVisible = true;
    },
    // 同步创建子网子组件传出来的dialog是否显示的数据
    syncCreateDialogVisibleData(data) {
      this.sshDialogVisible = data;
    },
    // 获取SSH数据
    getSSHListData() {
      // 基础参数
      const param = {
        region: this.selectedRegion,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      // 搜索部分添加参数
      if (this.currentSearchValue !== '') {
        switch (this.currentSearch) {
          case 'name': {
            param.elasticIpIds = this.currentSearchValue;
            break;
          }
        }
      }
      Ajax.get('/api/cps/listKeypairs', param)
        .then((res => {
          this.loading = false;
          this.tableData = res.data.keypairs;
          this.total = res.data.totalCount;
        }))
        .catch(async (err) => {
          const {response} = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },
    // 取region
    getRegion() {
      const target = this;
      const params = {
        networkType: NetworkTypeConstant.VPC
      };
      Ajax.get('/api/cps/getRegions',params)
        .then((res) => {
          target.regions = res.data.regions || [];
          for (let i = 0; i < target.regions.length; i++) {
            this.regionMap[target.regions[i].region] = target.regions[i].regionName;
          }
          const passedRegion = target.$route.params.region;
          if (passedRegion !== undefined) {
            target.selectedRegion = passedRegion;
          } else {
            target.selectedRegion = target.regions[0].region;
          }
          this.updateList('refresh')
        })
    },
    // 刷新
    updateList(type) {
      if (type === 'refresh') {
        this.loading = true;
        this.currentPage = 1;
      }
      this.getSSHListData();
    },
    updateListWithoutLoading(type){
      if (type === 'refresh') {
        this.currentPage = 1;
      }
      this.getSSHListData();
    },
    // 跳转到详情页
    jumpToDetail(item) {
      this.$router.push({
        path: `/ssh/detail`,
        query:{
          id: item.keypairId,
          region: item.region
        }
      });
    },
    // 切换每一页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.updateList('refresh');
    },
    // 切换当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSSHListData();
    },
    // 操作
    selectOpts(caseOps, row) {
      SSHPopHelper.operations(caseOps, this, row, 'list');
    },
  }
}
</script>

<style lang="scss">
  @import '~@/assets/scss/listComon';
  @import '~@/assets/scss/paginationCommon';
  @import '~@/assets/scss/messageBoxCommon';
  .ssh-list-container{
    span.jc-tooltip.a-disabled {
      color: #9e9e9e;
      cursor: not-allowed;
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/ssh/list/List.vue